import BaseStore from './base'

const schema = {
  '_id?': String,
  category: String,
  text: String,
  image: String,
  timestamp: Number,
  'campaignID?': String,
  'equipmentID?': String,
  'fieldID?': String,
  gpsLat: Number,
  gpsLng: Number,
  'gpsAccuracy?': Number,
  'gpsAge?': Number,
  'resolvedAt?': Number
}

export default class MarkerStore extends BaseStore {
  static get storageKey () { return 'tracker-markers' }
  static get apiFunction () { return 'postMarkers' }
  static get rawSchema () { return schema }

  static deflate (d) {
    return {
      ...d,
      gpsLng: Math.floor((d.gpsLng - 7) * 100000),
      gpsLat: Math.floor((d.gpsLat - 49) * 100000),
      fieldID: d.fieldID ? d.fieldID.replace('-0', '') : undefined,
      resolvedAt: d.resolvedAt ? Math.floor(d.resolvedAt / 1000) : undefined
    }
  }
}
